module.exports = __webpack_public_path__ + "img/cancelmeeting.fe169bb6.svg";